import {
  GIFT_VOUCHER_LIST, GIFT_VOUCHER_LIST_SUCCESS, GIFT_VOUCHER_LIST_FAILURE,
  GIFT_VOUCHER_DATA, GIFT_VOUCHER_DATA_SUCCESS, GIFT_VOUCHER_DATA_FAILURE,
  GIFT_VOUCHER_CREATE, GIFT_VOUCHER_CREATE_SUCCESS, GIFT_VOUCHER_CREATE_FAILURE,
  GIFT_VOUCHER_UPDATE, GIFT_VOUCHER_UPDATE_SUCCESS, GIFT_VOUCHER_UPDATE_FAILURE,
  GIFT_VOUCHER_DELETE, GIFT_VOUCHER_DELETE_SUCCESS, GIFT_VOUCHER_DELETE_FAILURE,
  GIFT_VOUCHER_SEARCH, GIFT_VOUCHER_SEARCH_SUCCESS, GIFT_VOUCHER_SEARCH_FAILURE,
  GIFT_VOUCHER_REDEEM, GIFT_VOUCHER_REDEEM_SUCCESS, GIFT_VOUCHER_REDEEM_FAILURE,
  GIFT_VOUCHER_VOID, GIFT_VOUCHER_VOID_SUCCESS, GIFT_VOUCHER_VOID_FAILURE,
  GIFT_VOUCHER_RESEND_EMAIL, GIFT_VOUCHER_RESEND_EMAIL_SUCCESS, GIFT_VOUCHER_RESEND_EMAIL_FAILURE,
} from "./actionType";

export const giftVoucherList = () => ({ type: GIFT_VOUCHER_LIST });
export const giftVoucherListSuccess = (data) => ({ type: GIFT_VOUCHER_LIST_SUCCESS, payload: data });
export const giftVoucherListFailure = (error) => ({ type: GIFT_VOUCHER_LIST_FAILURE, payload: error });

export const giftVoucherData = (data) => ({ type: GIFT_VOUCHER_DATA, payload: data });
export const giftVoucherDataSuccess = (data) => ({ type: GIFT_VOUCHER_DATA_SUCCESS, payload: data });
export const giftVoucherDataFailure = (error) => ({ type: GIFT_VOUCHER_DATA_FAILURE, payload: error });

export const giftVoucherCreate = (data) => ({ type: GIFT_VOUCHER_CREATE, payload: data });
export const giftVoucherCreateSuccess = (data) => ({ type: GIFT_VOUCHER_CREATE_SUCCESS, payload: data });
export const giftVoucherCreateFailure = (error) => ({ type: GIFT_VOUCHER_CREATE_FAILURE, payload: error });

export const giftVoucherUpdate = (data) => ({ type: GIFT_VOUCHER_UPDATE, payload: data });
export const giftVoucherUpdateSuccess = (data) => ({ type: GIFT_VOUCHER_UPDATE_SUCCESS, payload: data });
export const giftVoucherUpdateFailure = (error) => ({ type: GIFT_VOUCHER_UPDATE_FAILURE, payload: error });

export const giftVoucherDelete = (data) => ({ type: GIFT_VOUCHER_DELETE, payload: data });
export const giftVoucherDeleteSuccess = (data) => ({ type: GIFT_VOUCHER_DELETE_SUCCESS, payload: data });
export const giftVoucherDeleteFailure = (error) => ({ type: GIFT_VOUCHER_DELETE_FAILURE, payload: error });

export const giftVoucherSearch = (data) => ({ type: GIFT_VOUCHER_SEARCH, payload: data });
export const giftVoucherSearchSuccess = (data) => ({ type: GIFT_VOUCHER_SEARCH_SUCCESS, payload: data });
export const giftVoucherSearchFailure = (error) => ({ type: GIFT_VOUCHER_SEARCH_FAILURE, payload: error });

export const giftVoucherRedeem = (data) => ({ type: GIFT_VOUCHER_REDEEM, payload: data });
export const giftVoucherRedeemSuccess = (data) => ({ type: GIFT_VOUCHER_REDEEM_SUCCESS, payload: data });
export const giftVoucherRedeemFailure = (error) => ({ type: GIFT_VOUCHER_REDEEM_FAILURE, payload: error });

export const giftVoucherVoid = (data) => ({ type: GIFT_VOUCHER_VOID, payload: data });
export const giftVoucherVoidSuccess = (data) => ({ type: GIFT_VOUCHER_VOID_SUCCESS, payload: data });
export const giftVoucherVoidFailure = (error) => ({ type: GIFT_VOUCHER_VOID_FAILURE, payload: error });

export const giftVoucherResendEmail = (data) => ({ type: GIFT_VOUCHER_RESEND_EMAIL, payload: data });
export const giftVoucherResendEmailSuccess = (data) => ({ type: GIFT_VOUCHER_RESEND_EMAIL_SUCCESS, payload: data });
export const giftVoucherResendEmailFailure = (error) => ({ type: GIFT_VOUCHER_RESEND_EMAIL_FAILURE, payload: error });
